import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { ModeTabsSlot } from "@/app/components/ModeTabs/ModeTabsPortal";
import { GoalsLoader } from "@/apps/goals/components/GoalsLoader/GoalsLoader";
import { WithdrawButton } from "@/apps/goals/components/WithdrawButton/WithdrawButton";
import { useGoalsStore } from "@/apps/goals/store/goalsStore";
import { getGoalsScreenUrl } from "@/apps/goals/utils/goalsRoutes";
import cls from "./styles.module.scss";

export const GoalsAppPage = () => {
  const screen = useGoalsStore((state) => state.screen);
  const location = useLocation();
  const targetPath =
    screen === "loading" ? undefined : getGoalsScreenUrl(screen);

  if (screen === "loading") {
    return <GoalsLoader />;
  }

  if (location.pathname !== targetPath) {
    return (
      <Navigate
        to={{
          pathname: targetPath,
          search: location.search,
        }}
        replace
      />
    );
  }

  return (
    <main
      className={[
        cls.wrapper,
        screen === "wheel" || screen === "regionSelector" ? cls.softEnter : "",
      ].join(" ")}
    >
      {screen !== "regionSelector" && (
        <>
          <ModeTabsSlot className={cls.modeTabs} />
          <WithdrawButton />
        </>
      )}
      <Outlet />
    </main>
  );
};
